export default function setSearchCityAction(searchCity) {
    return {
        type: 'SET_SEARCH_CITY',
        payload: searchCity
    }
}